//import settings from "./js/settings.js";
//import db from './js/jsstoreHelper.js'; // Library to manage the browser IndexedDB
//import ls from './js/localStorageHelper.js'; // Library to manage the localstorage
//import customDialogHelper from './js/modal.js'; // My library to manage modal dialogs

// With the async import is possible to workaround the js file caching problem adding the version in querystring
// const { default: settings } = await import('./js/settings.js?v=' + new Date().toISOString().slice(0,10));
// const { default: db } = await import('./js/jsstoreHelper.js?v=' + settings.version);
// const { default: customDialogHelper } = await import('./js/modal.js?v=' + settings.version);

import settings from './js/settings.js';
import db from './js/jsstoreHelper.js';
import customDialogHelper from './js/modal.js';

var options = {};

//console.log(`endpoint:${settings.apiEndPoint}`);

/**------------------------------------
This function prevents the residual show of the wait dialog
when the user returns here with the browser back button.
-------------------------------------*/
addEventListener("pageshow", (event) => {
	// Detect the type of navigation
	if (window.performance.getEntriesByType("navigation")[0].type == 'back_forward') {
		customDialogHelper.HideWaitDialog();
	}
});

/**------------------------------------
Show the page that is initially hided to prioritize the splash screen.
-------------------------------------*/
var showPage = function () {
	$('header,main').show();
}

$(async function () {

	// The splash screen appears on the first page load.
	// If the url finishes with an # the splash screen is not shown.

	// If the user agent contains the string median the splash screen won't be shown.
	//if (document.location.href.indexOf("#") > -1 || navigator.userAgent.indexOf('median') > -1) {
	// Not really satisfied of the median solution.
	if (document.location.href.indexOf("#") > -1) {
		showPage();
	}
	else {
		// It's the first visit. Show the splash screen
		var dialog = new customDialogHelper.genericDialog({
			modalDialogId: 'splashScreen',
			width: 'f',
			template: $('#dialogSplashScreen').html(),
			showHeader: false,
			showFooter: false,
		});
		dialog.ShowDialog();

		// Calculate the optimal splash image size
		var w = $('#splashScreen').width() * 80 / 100;
		if (w > 600) { w = 600; }
		var wHalf = w / 2;
		$('#splashScreen img')
			.css('margin-left', `-${wHalf.toFixed()}px`)
			.css('width', w.toFixed() + 'px');

		$('#splashScreen img').fadeIn(2000);
		// In some seconds show the page and hide the splash.
		setTimeout(() => {
			showPage();
			dialog.Hide();
		}, 4000);

		// Add hash to URL
		document.location.href += "#";
	}
	
	// Load the options.
	options = await db.getOptions();
	
	/**------------------------------------
	Click on topic and archive buttons.
	-------------------------------------*/
	
	// Click on a topic button.
	$('#listTopic li button').on('click', function () {

		var topic = $(this).parent('li').data('topic');
		
		customDialogHelper.ShowWaitDialog();
		// The user wants to play
		var success = function () {
			// Local image found. Go directly to the game
			window.location.href = './viewPlay.html?v=' + settings.version;
		}
		var failure = function () {
			// No local image found. Ask for one to the remote API
			getImageFromRemote(topic);
		};
		
		db.readImageFromLocal(topic, success, failure);
	});

	// Click on the archive button.
	$('button.btnArchive').on('click', function () {
		// Go to the archive
		window.location.href = `./viewArchive.html?v=` + settings.version;
	})

	/**------------------------------------
	Navigation
	-------------------------------------*/
	
	$('nav a.navSettings').on('click', function () {
		var dialog = processNavigator('dialogSettings');
		
		processRadioDifficulty();
		processSwitchOutline();
		processSwitchSound();
		processswitchAutoBrush();
		
		$('.divOptions button').off('click');

		// Clear the local data
		$('.btnClearEverything').on('click', function () {
			$('.btnClearEverythingConfirm').parent('div').removeClass('d-none');
			$('.btnClearEverything').addClass('d-none');
		});

		$('.btnClearEverythingConfirm').on('click', async function () {
			dialog.Hide();
			customDialogHelper.ShowWaitDialog();

			await db.emptyDB();
			
			location.reload();
		});

		$('.btnClearEverythingCancel').on('click', function () {
			$('.btnClearEverythingConfirm').parent('div').addClass('d-none');
			$('.btnClearEverything').removeClass('d-none');
		});
	});

	$('nav a.navHelp').on('click', function () {
		processNavigator('dialogHelp');
	});

	$('nav a.navAbout').on('click', function () {
		processNavigator('dialogAbout');
	});
	
	// Asynchronously load the done image icons
	db.getAllProcessingImages(function (arr) {
		for (var i = 0; i < arr.length; i++) {
			$(`#listTopic li[data-topic='${arr[i]}'] i.processing`).removeClass('d-none');
		}
	})
})

/**------------------------------------
Create the content for every navigator dialog.
@param {String} templateId - The template id that contains the dialog text and controls.
-------------------------------------*/
var processNavigator = function (templateId) {
	
	var template = $('#' + templateId).html();

	// Back button
	template = template.replace('{{backButton}}', $('#dialogBackButton').html());
	
	// Version
	template = template.replace('{{version}}', settings.version);

	// Options
	template = template.replace('{{percentageToFillAColor}}', options.percentageToFillAColor);
	template = template.replace('{{percentageToWin}}', options.percentageToWin);

	var dialog = new customDialogHelper.genericDialog({
		modalDialogId: 'dialogNavigator',
		width: 'f',
		template: template,
		showHeader: false,
		showFooter: false
	});

	dialog.ShowDialog();

	// Close the bootstrap menu
	$('.navbar-collapse').collapse('hide');

	if (templateId == 'dialogHelp') {
		$('#dialogNavigator button.btnArchive')
			.off()
			.on('click', function () {
				// Go to the archive directly from modal
				window.location.href = `./viewArchive.html?v=` + settings.version;
				dialog.Hide();
			})
	}

	return dialog;
}

/**------------------------------------
Process the radio buttons to set the game difficult.
-------------------------------------*/
var processRadioDifficulty = function () {
	
	var radio = null;
	switch (options.difficulty) {
		case '1':
			radio = $('div.divOptions input[name="difficulty"][value="1"]');
			break;
		case '2':
		default:
			radio = $('div.divOptions input[name="difficulty"][value="2"]');
			break;
		case '3':
			radio = $('div.divOptions input[name="difficulty"][value="3"]');
			break;
	}

	var descr = $(radio)
		.prop("checked", true)
		.trigger('focus')
		.data('descr');
	$('div.divOptionsDifficultyDescr').html(descr);
	
	// Events
	$('div.divOptions input[name="difficulty"]')
		.off('change')
		.on('change', function () {
			
			options.difficulty = $(this).val();
			db.saveOptions(options, (retOptions)=> {
				options = retOptions;
				processRadioDifficulty();
			});
		});
};

/**------------------------------------
Process the switch to activate/deactivate the shadow outline.
-------------------------------------*/
var processSwitchOutline = function () {

	$('div.divOptions input.switchOutline')
		.prop('checked', options.outline)
		.off('change')
		.on('change', function () {
			options.outline = $(this).is(':checked');
			db.saveOptions(options, (retOptions) => { options = retOptions; });
		});
};

/**------------------------------------
Process the switch to activate/deactivate the sound effects.
-------------------------------------*/
var processSwitchSound = function () {

	$('div.divOptions input.switchSound')
		.prop('checked', options.sound)
		.off('change')
		.on('change', function () {
			options.sound = $(this).is(':checked');
			db.saveOptions(options, (retOptions) => { options = retOptions; });
		});
};

/**------------------------------------
Process the switch to activate/deactivate the next available brush selection.
-------------------------------------*/
var processswitchAutoBrush = function () {

	$('div.divOptions input.switchAutoBrush')
		.prop('checked', options.autoBrush)
		.off('change')
		.on('change', function () {
			options.autoBrush = $(this).is(':checked');
			db.saveOptions(options, (retOptions) => { options = retOptions; });
		});
};

/**------------------------------------
Ask for an image from the remote API.
@param {string} topic - The image category.
-------------------------------------*/
var getImageFromRemote = async function (topic) {

	// Get the already done image for a certain topic.
	var arrDoneListImageIds = await db.getRemoteIdListOfDoneImages(topic);

	// Ask the web api for a new image.
	getImageAPI(topic, arrDoneListImageIds, function (data) {
			
		var successWriteImage = function () {
			window.location.href = './viewPlay.html?v=' + settings.version;
		};

		var failureWriteImage = function () {
			customDialogHelper.HideWaitDialog();
			var alertDialog = new customDialogHelper.genericDialog({
				width: 'm',
				textCentered: true,
				showHeader: false,
				showFooter: false,
			});

			alertDialog.ShowDialog(`Nothing new available.<br/>Find something in another category.`);
			setTimeout(() => {
				alertDialog.Hide();
			}, 3000);
		}

		if (!data) {
			failureWriteImage();
			return;
		}

		// The returned SVG (property SVGz) is a gZipped string and needs to be unpacked.
			
		// Un-base64.
		var gzippedBuffer = base64ToBytes(data.SVGz);

		// Deflate with pako.
		var unzipped = pako.ungzip(gzippedBuffer);

		// The resulting array is converted and saved to the data.SVG object as the original string.
		data.SVG = new TextDecoder('utf8').decode(unzipped);

		// Alternative option. Extremely slow.
		// var n= unzipped.length;
		// for (var i = 0; i < n; i++) {
		// 	data.SVG += String.fromCharCode(unzipped[i]);
		// }
			
		// Proceed with the DB operations.
		db.writeImageFromRemote(data, successWriteImage, failureWriteImage);
	})
}

/**------------------------------------
Decode a base64 encoded byte array.
@param {String} base64 - The base64 encoded array.
-------------------------------------*/
var base64ToBytes = function (base64) {
	const binaryString = atob(base64); // Decode Base64 to binary string
	const len = binaryString.length;
	const bytes = new Uint8Array(len); // Create a byte array

	for (let i = 0; i < len; i++) {
		bytes[i] = binaryString.charCodeAt(i); // Fill the byte array with character codes
	}

	return bytes;
}

/**------------------------------------
Get a new image for a certain topic excluding the already done images.
@param {String} topic - The image category.
@param {Array} arrDoneListImageIds - The list of already done images.
@param {Object} successCallback - The callback.
-------------------------------------*/
var getImageAPI = function (topic, arrDoneListImageIds, successCallback) {
	
	var request = {
		topic: topic,
		doneImageList: arrDoneListImageIds
	}

	$.ajax({
		url: `${settings.apiEndPoint}SVGDispacherApi`,
		type: "POST",
		dataType: "json",
		data: request,
		success: successCallback,
	});
}
